import Vue from 'vue'
import VueRouter from 'vue-router'
import { publicPath } from '../../vue.config'
//import { baseUrl } from '../../vue.config'


Vue.use(VueRouter)

  const routes = [
  { path: '*', redirect: '/' },
  { path: '/', name: 'home', component: () => import('@/components/home.vue') },
  
  { path: '/expedientes', name: 'expedientes', component: () => import('@/components/expedientes.vue') },
  { path: '/proveedores', name: 'proveedores', component: () => import('@/components/proveedores.vue') },

  { path: '/expediente', name: 'expediente', component: () => import('@/components/exped.vue') },

]

const router = new VueRouter(
{
  base: publicPath,
  mode: 'history', 
  routes,

  scrollBehavior() {
    return {x: 0, y: 0} 
  }
})

export default router

